// keys for localstorage
export enum StorageKey {
    accessToken = "i2i_accessToken",
    // Which role the user is acting as. Not session data and not a credential:
    // it is a UI choice that has to survive a reload, since identity itself is
    // rebuilt from the profile after every silent refresh.
    activeRole = "i2i_active_role",
    // Whether this browser has held a session. Not a credential — it unlocks
    // nothing, and says no more than the header already shows. It only lets a
    // public page skip the refresh call for visitors who were never signed in.
    hadSession = "i2i_had_session",
    shouldAlwaysAsk = "shouldAlwaysAsk",
    teletherapyCurrentRoute ="teletherapyCurrentRoute",
}
